// extracted by mini-css-extract-plugin
module.exports = {"tab-button":"FundCentreMainTabs_tab-button__JHPoQ","tab-button--active":"FundCentreMainTabs_tab-button--active__iG466","bi":"FundCentreMainTabs_bi__vTN__"};